import { createRequestTypes } from 'common/websocket-redux';

export const GET_CLAIMS_REQUEST = createRequestTypes(
  'claims/GET_CLAIMS_REQUEST',
);
export const VISITED = 'claims/VISITED';
export const EXITED = 'claims/EXITED';
export const CLAIM_SELECTED = 'claims/CLAIM_SELECTED';
export const OPTIONS_CHANGED = 'claims/OPTIONS_CHANGED';
